const DottedSeparator = () => (
    <div className="flex-grow mx-2 border-b-2 border-dotted border-gray-400 self-end mb-0" />
  );

export default DottedSeparator;